import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan'];
const NAMES = ['María', 'Carolina', 'Luciana', 'Gabriela', 'Valeria', 'Andrea', 'Florencia', 'Natalia', 'Paula', 'Romina', 'Silvina', 'Daniela'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    const interval = setInterval(() => {
      showPopup();
    }, Math.random() * (12000 - 8000) + 8000); // Random between 8-12s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const showPopup = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-50 animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-194">
      <div className="bg-white rounded-lg shadow-xl p-4 border-l-4 border-green-500 flex items-start gap-3 max-w-sm" data-id="element-195">
        <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-196">
          <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-197" />
        </div>
        <div className="flex-1 pr-6" data-id="element-198">
          <p className="text-sm font-medium text-gray-900" data-id="element-199">
            <span className="font-bold" data-id="element-200">{data.name}</span> de {data.city}
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-201">
            acaba de comprar este libro
          </p>
        </div>
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-202">
          <X size={14} data-id="element-203" />
        </button>
      </div>
    </div>;
}